import { Avatar, Flex, Icon, LinkButton, Text } from '@homebotapp/hb-react-component-catalog'
import { useSelector } from 'react-redux'
import { selectCustomerIsRealEstateAgent, selectCustomerProfile } from '../../../../store/selectors/customerProfile'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  resourceFrom: {
    id: 'CustomerListingsCard.resourceFrom',
    defaultMessage: 'A resource from, {name}'
  },
  seeListingsFromMySite: {
    id: 'CustomerListingsCard.seeListingsFromMySite',
    defaultMessage: 'See more listings on my site'
  }
})
export const CustomerListingsCard = () => {
  const intl = useIntl()

  const customerProfile = useSelector(selectCustomerProfile) || {}

  const hasCustomListingsFlagEnabled = customerProfile?.features?.some(
    (feature: string) => feature === 'customListings'
  )

  const isCustomerREA = useSelector(selectCustomerIsRealEstateAgent)

  if (!customerProfile?.listingsUri || !isCustomerREA || !hasCustomListingsFlagEnabled) {
    return null
  }

  return (
    <Flex
      alignItems='center'
      backgroundColor='neutral.50'
      borderWidth={0.5}
      borderColor='neutral.300'
      borderRadius='16px'
      p='12px 10px'
      gap='12px'
      mb={5}
    >
      <Avatar size='sm' src={customerProfile?.photoUri} />

      <Flex flexDirection={['column', 'row']} justifyContent={['flex-start', 'space-between']} flex={1}>
        <Text textTransform='uppercase' m={0} size='2sx' fontWeight='bold'>
          {intl.formatMessage(MSG.resourceFrom, { name: `${customerProfile?.firstName} ${customerProfile?.lastName}` })}
        </Text>
        <LinkButton
          size='xs'
          rightIcon={<Icon name='external-link' />}
          href={customerProfile?.listingsUri}
          target='_blank'
        >
          {intl.formatMessage(MSG.seeListingsFromMySite)}
        </LinkButton>
      </Flex>
    </Flex>
  )
}
